/*
 * TEPO ekleme -> sepet tazeleme köprüsü
 * ------------------------------------
 * Minimog'un stok dosyası DEĞİLDİR — RimaPeçete'ye özel eklendi.
 *
 * SORUN
 * TEPO (Qikify Product Options) temanın sepete ekle butonunu gizleyip
 * (button[name="add"] -> display:none) üstüne kendi butonunu koyuyor:
 * button#tcustomizer-add, type="button". Bu buton formu GÖNDERMEDİĞİ için
 * Minimog'un <product-form> öğesindeki onSubmitHandler hiç çalışmıyor.
 * O handler, sepet çekmecesini tazeleyen üç işi tek başına yapıyordu:
 *   1) 'cart:grouped-sections' ile yeniden çizilecek bölümleri toplamak,
 *   2) /cart/add isteğine 'sections' alanını eklemek,
 *   3) yanıt dönünce pubSubEvents.cartUpdate olayını yayınlamak.
 * TEPO kendi fetch('/cart/add.js') isteğini sections olmadan atıyor ve
 * hiçbir tema olayı yayınlamıyor. Sonuç: ürün sepete giriyor ama çekmece
 * ve sepet sayacı eski hâlde kalıyor; ancak sayfa yenilenince görünüyor.
 *
 * ÇÖZÜM
 * TEPO ekleme bitince 'tcustomizer-after-cart-added' olayını yayınlıyor.
 * Temanın da tam bu iş için hazır kancası var: 'cart:refresh'. MCartItems
 * bu olayı dinleyip sepet bölümlerini sunucudan yeniden çekiyor, başlık /
 * gövde / alt bölümü ve sepet sayacını yeniden çiziyor, detail.open true
 * ise çekmeceyi açıyor. Aradaki bağlantıyı burada kuruyoruz.
 *
 * Not: 'cart:refresh' yalnız TEPO eklemesinde tetiklenir. Seçeneksiz
 * ürünlerde tema kendi akışını çalıştırdığı için bu dosya devreye girmez.
 */
(function () {
  var TEPO_EVENT = 'tcustomizer-after-cart-added';
  var COALESCE_MS = 120;
  var timer = null;

  function refreshCart() {
    timer = null;
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }

  document.addEventListener(TEPO_EVENT, function () {
    // TEPO çok kalemli eklemede olayı birden fazla yayabiliyor; tek tazelemede birleştir.
    if (timer) clearTimeout(timer);
    timer = setTimeout(refreshCart, COALESCE_MS);
  });
})();
